const [ w, d ] = [ window, document ]

const jqReady = () => {
  // slot適用
  $.when( w.load['menu-layout'] ).then( (data,slot) => $('[data-slot="plans"]').html( slot ) )
}

export default function MENU () {
  $( jqReady )
}